import { render } from "./CustomerPrivacy.vue?vue&type=template&id=d088d3b8&scoped=true"
import script from "./CustomerPrivacy.vue?vue&type=script&lang=js"
export * from "./CustomerPrivacy.vue?vue&type=script&lang=js"

import "./CustomerPrivacy.vue?vue&type=style&index=0&id=d088d3b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d088d3b8"]])

export default __exports__